import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component({})
export default class H5Video extends Vue {

    // prop
    @Prop({ default() { return {}}}) data!: any

    // data
    public info: any = {
    }
    public progress = 0
    public timeId = null
    @Watch('data', { deep: true })
    public onDataChange(val, old) {
        console.log(val)
        this.renderPage(val)
    }

    // methods
    public async renderPage(data) {
        this.info = data
    }

    // mounted
    public mounted() {
        const {
            id,
            token
        } = this.$route.query
      
        this.renderPage(this.data)

        const self = this
        const myVideo: any = this.$refs.myVideo

        myVideo.addEventListener('timeupdate', () => {
            self.progress = Math.ceil(myVideo.currentTime)
        }, false)

        myVideo.addEventListener('ended', () => {
        })
    }
}
